// Shared copy also keeps publish consequences consistent across domain panels.
export const RULE_SET_COPY = {
  madar: {
    label: 'قواعد مدار', title: 'قواعد مدار',
    consequence: 'تا یک نسخه منتشر نشود، ثبت شبکهٔ این اپراتور در مدار انجام نمی‌شود.',
    start: 'شروع با قواعد پایه',
    publish: 'ثبت‌های بعدی از این قواعد استفاده می‌کنند. متراژ دستی ثبت‌های قبلی تغییر نمی‌کند.',
  },
  design: {
    label: 'طراحی', title: 'قواعد طراحی',
    consequence: 'تا یک نسخه منتشر نشود، طراحی برای این اپراتور اجرا نمی‌شود.',
    start: 'شروع با مقدارهای پیش‌فرض موتور',
    publish: 'طرح‌های جدید از این مقدارها شروع می‌شوند. طرح‌های موجود مقدارهای خودشان را نگه می‌دارند.',
  },
  tariffs: {
    label: 'فهرست بها', title: 'فهرست بها',
    consequence: 'تا یک نسخه منتشر نشود، هزینهٔ طرح‌های این اپراتور محاسبه نمی‌شود.',
    start: 'شروع با فهرست خالی',
    publish: 'قیمت‌گذاری‌های بعدی با این فهرست بها انجام می‌شود. هزینهٔ ثبت‌شدهٔ طرح‌ها عوض نمی‌شود تا دوباره قیمت‌گذاری شوند.',
  },
  supervision: {
    label: 'قواعد نظارت', title: 'قواعد نظارت',
    consequence: 'تا یک نسخه منتشر نشود، بررسی هوش مصنوعی و بازرسی دستی برای این اپراتور انجام نمی‌شود و فرایند نصب منتشر نمی‌شود.',
    start: 'شروع با متن‌های خالی',
    publish: 'کارهایی که از این به بعد شروع می‌شوند و بازرسی‌های دستی جدید با این قواعد بررسی می‌شوند. کارهای در جریان با نسخه‌ای که با آن شروع شده‌اند ادامه می‌دهند.',
  },
  installation: {
    label: 'فرایند نصب', title: 'فرایند نصب',
    consequence: 'تا یک نسخه منتشر نشود، کار نصب برای این اپراتور شروع نمی‌شود و به نیروی اجرایی پیشنهاد نمی‌شود.',
    start: 'شروع با یک مرحلهٔ خالی',
    publish: 'کارهایی که از این به بعد شروع می‌شوند این مراحل را می‌گیرند. کارهای در جریان با نسخهٔ قبلی تمام می‌شوند.',
  },
};
